<template>
  <div class="boxcontainer">

    <div class="navBar">
      <span style="float: left">{{this.panelTitle}}</span>
      <van-button v-if="hasMore" v-on:click="BTActionMore()" style="float: right;right: -20px; border: none;" icon="arrow" type="default" />
    </div>

    <!--分割线-->
    <van-divider style="margin: 0px;padding: 0px" />

    <!--网格菜单-->
    <div class="gridMenu">
      <van-grid :border="false">
        <van-grid-item v-for="(item,index) in menuListUi" :key="index" @click="menuClick(item)">
          <van-icon class="iconfont" class-prefix='icon' :name='item.icon' style="font-size: 2.5rem" />
          <span class="gridItemTitle">{{item.title}}</span>
          <div v-if="item.num !=0" class="van-info-num">{{item.num}}</div>
        </van-grid-item>
      </van-grid>
    </div>

  </div>
</template>




<script>
import "../assets/appicons/font_1719792_w8dw4niwvmq/iconfont.css";
import { userIndex } from "@/api/index";

export default {
  name: "userCenterMenuPanel",
  props: {
    panelTag: {
      //菜单面板标签
      type: String,
      default: "default"
    },
    panelTitle: {
      //面变标题
      type: String,
      default: "面板标题"
    },
    menuList: {
      //面板菜单项
      type: Array,
      default: new Array()
    },
    hasMore: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      menuListUi: null
    };
  },
  created() {
    this.menuListUi = null;
    this.menuListUi = JSON.parse(JSON.stringify(this.menuList));
    this.menuListUi.forEach(item => {
      item.num = 0;
    });
    if (sessionStorage.getItem("Token") == null) return;
    if (this.menuList[0].tag != "orderMenu") return;
    userIndex().then(res => {
      console.log(res);
      if (res.data.errno == 0) {
        this.menuList.forEach((item, index) => {
          console.log(res.data.data.order.unpaid);
          if (index == 0) {
            item.num = res.data.data.order.unpaid;
          } else if (index == 1) {
            item.num = res.data.data.order.unship;
          } else if (index == 2) {
            item.num = res.data.data.order.unrecv;
          } else if (index == 3) {
            item.num = res.data.data.order.uncomment;
          }
        });
        this.menuListUi = JSON.parse(JSON.stringify(this.menuList));
      }
    });
  },
  methods: {
    BTActionMore() {
      this.$emit("ActionMore", this.panelTag);
    },
    mmm() {
      alert("111");
    },
    menuClick(menu) {
      this.$emit("ActionMenuItemClick", menu);
    }
  }
};
</script>

<style scoped lang="scss">
/deep/ .van-grid-item__content--center {
  position: relative;
}
.van-info-num {
  position: absolute;
  top: 1.5rem;
  right: 3.3rem;
  box-sizing: border-box;
  min-width: 1.6rem;
  padding: 0 3px;
  color: #fff;
  font-weight: 500;
  font-size: 1.2rem;
  line-height: 1.4rem;
  text-align: center;
  background-color: #ee0a24;
  border: 1px solid #fff;
  border-radius: 1.6rem;
  transform: translate(50%, -50%);
  transform-origin: 100%;
}
.gridMenu {
  .gridItemTitle {
    margin-top: 5px;
    font-size: 1.2rem;
  }
}
.boxcontainer {
  // border-bottom: solid 1px lightgray;
  // background-color: white;
  // border-bottom: 0;
  // background-color: white;
  background: #fff;
  overflow: hidden;
  width: 95.2%;
  margin: 1rem auto 0;
  box-shadow: 0 5px 1.6rem 0 rgba(0, 0, 0, 0.05);
  border-radius: 8px;
}
.navBar {
  height: 4.5rem;
  line-height: 4.5rem;
  font-size: 1.4rem;
  padding-left: 2rem;
  padding-right: 2rem;
  background-color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/userCenterMenuPanel.vue